import React from "react";

function About() {
  return (
    <div className="about">
      <div class="container">
        <div class="row align-items-center my-5">
          <div class="col-lg-7">
            <img
              class="img-fluid rounded mb-4 mb-lg-0"
              src="https://image.shutterstock.com/image-photo/about-us-details-contact-data-260nw-377373607.jpg"
              alt=""
              width="900px"
              height="400px"
            />
          </div>
          <div class="col-lg-5">
            <h1 class="font-weight-light">About</h1>
            <p>
              This is my online my store est in 2008
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
